import React, {useEffect, useState} from 'react';
import {Navigate} from 'react-router-dom';
import {Loader2} from 'lucide-react';

const ProtectedRoute = ({children}) => {
    const [loading, setLoading] = useState(true);
    const [authenticated, setAuthenticated] = useState(false);

    useEffect(() => {
        // Check for token
        const token = localStorage.getItem('accessToken');
        if (token) {
            setAuthenticated(true);
        }
        setLoading(false);
    }, []);

    if (loading) {
        return (
            <div className="flex items-center justify-center h-screen bg-gray-100">
                <div className="flex flex-col items-center gap-4">
                    <Loader2 size={40} className="animate-spin text-blue-600"/>
                    <p className="text-gray-600 font-medium">Verifying your access...</p>
                </div>
            </div>
        );
    }

    if (!authenticated) {
        return <Navigate to="/"/>;
    }

    return children;
};

export default ProtectedRoute;